import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Conjunction.scss'



const Conjunction = () => {
    return(
        <div className="Conjunction-container">
            <InnerNav/>
            <div className="Conjunction-content">
                <Zodiac/>

                <div className="planet-header">
                    <h3>Planets Conjunction</h3>
                </div>

                <div className="planet-grid">
                    <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/The_Earth_seen_from_Apollo_17.jpg/960px-The_Earth_seen_from_Apollo_17.jpg" alt="" />
                        <p>Earth</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://static.scientificamerican.com/sciam/cache/file/C454F5A6-536E-4C9F-AA6AF354BB85A85B_source.jpg" alt="" />
                        <p>Mars</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://storage.noirlab.edu/media/archives/images/screen/noao0107a.jpg" alt="" />
                        <p>Moon</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQomZGx-yz1j75HbCa5X58okXWQebxScAAWvw&s" alt="" />
                        <p>Mercury</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://static.vecteezy.com/system/resources/previews/033/497/874/non_2x/a-picture-of-the-planet-saturn-taken-from-space-generative-ai-free-photo.jpg" alt="" />
                        <p>Saturn</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://www.esa.int/var/esa/storage/images/esa_multimedia/images/2004/06/high_resolution_globe_of_jupiter2/17891538-2-eng-GB/High_resolution_globe_of_Jupiter.jpg" alt="" />
                        <p>Jupiter</p>
                    </div>
                </div>
                <PlanetLinks/>
            </div>
            <Footer/>
        </div>
    )
}
export default Conjunction;